import { connect } from 'react-redux'
import { change } from 'redux-form'

import ImageInput from './ImageInput'
import { modal } from 'store/entities/modal/actions'

const mapDispatchToProps = {
  showModal: modal.show,
  changeReduxForm: change,
}

export default connect(null, mapDispatchToProps)(ImageInput)
